<template>
    <section class="section">
        <p v-t="'Privacy.title'" class="title has-text-centered"></p>
        <div class="columns is-centered">
            <div class="column is-5">
                <p
                    v-t="'Privacy.responsible_title'"
                    class="subtitle has-text-weight-bold"
                ></p>
                <p>
                    {{ $t('Privacy.responsible_description') }}
                    <a
                        :href="`mailto:${$t('Privacy.responsible_email')}`"
                        class="has-text-weight-bold"
                        >{{ $t('Privacy.responsible_email') }}</a
                    >
                </p>
                <p
                    v-t="'Privacy.conservation_title'"
                    class="subtitle has-text-weight-bold"
                ></p>
                <p v-t="'Privacy.conservation_description'"></p>
                <p
                    v-t="'Privacy.rights_title'"
                    class="subtitle has-text-weight-bold"
                ></p>
                <p v-t.preserve="'Privacy.rights_description'"></p>
            </div>
            <!--div class="column"></div-->
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style scoped>
.column > .subtitle {
    margin-bottom: 0;
    padding-top: 1rem;
    padding-bottom: 1rem;
}
</style>
